<template>
    <div class="qyh-card">
        <div class="card">
            <div class="c-fir-lev">
                <slot name="first-level"></slot>
            </div>
            <div class="card-fir">
                <div class="card-title">
                    <slot name="title"></slot>
                </div>
                <div class="card-edit">
                    <slot name="edit"></slot>
                </div>
            </div>
            <div class="card-sec">
                <slot name="other"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QyhCard',
    props: {
        title: {
            type: String
        },
    }

}
</script>

<style scoped>
.qyh-card {
    background-color: #fff;
}

.qyh-card .card {
    box-shadow: 0 15px 30px rgba(0, 0, 0, .3);
    border: 1px solid rgb(200, 200, 200);
    padding: 0.2rem 0.4rem;
    border-radius: 10px;
}

.qyh-card .card-fir {
    display: flex;
    border-bottom: 1px solid rgb(222, 222, 222);
    padding-bottom: 0.2rem;
    justify-content: center;
    align-items: center;
}

.qyh-card .card-title {
    vertical-align: bottom;
    text-align: center;
}

.qyh-card .card-edit {
    margin-left: auto;
    vertical-align: bottom;
}

.qyh-card .card-sec {
    margin-top: 0.2rem;
}
.qyh-card .c-fir-lev {
    margin-bottom: 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/commonReform/QyhCard.vue